<template>
  <form>
    <Toast position="top-center" />
    <div class="flex flex-wrap">
      <input type="hidden" id="menu_active" />
      <div class="pr-6 pb-8 w-full lg:w-1/4">
        <label for="state" class="form-label">Estado</label>
        <select
          id="state"
          v-model="form.state_id"
          class="form-control form-select"
          :menu="['flag', 'bus', 'briefcase', 'invoice', 'departure', 'security']"
          :disabled="loading"
          @change="getCities()"
          required
        >
          <option :value="null" disabled selected>Selecione o Estado</option>
          <option v-for="state_ in states" :key="state_.id" :value="state_.id">
            {{ state_.name }}
          </option>
        </select>
        <span v-if="!form.state_id" class="text-red-500">*Campo obrigatório.</span>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/4">
        <label for="city" class="form-label">Cidade</label>
        <select
          id="city"
          v-model="form.city_id"
          class="form-control form-select"
          :menu="['flag', 'bus', 'briefcase', 'invoice', 'departure', 'security']"
          :disabled="loading"
          @change="setCC()"
          required
        >
          <option :value="null" disabled selected>Selecione uma cidade</option>
          <option v-for="city_ in cities" :key="city_.id" :value="city_.id">
            {{ city_.name }}
          </option>
        </select>
        <span v-if="!form.city_id" class="text-red-500">*Campo obrigatório.</span>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/4">
        <label for="start-date" class="form-label">Data Inicial</label>
        <input
          id="start-date"
          v-model="form.start_date"
          class="form-control form-input"
          type="date"
          :menu="['flag', 'bus', 'briefcase', 'invoice', 'departure', 'security']"
          :disabled="loading"
          required
        />
        <span v-if="!form.start_date" class="text-red-500">*Campo obrigatório.</span>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/4">
        <label for="end-date" class="form-label">Data Final</label>
        <input
          id="end-date"
          v-model="form.end_date"
          class="form-control form-input"
          type="date"
          :menu="['flag', 'bus', 'briefcase', 'invoice', 'departure', 'security']"
          :disabled="loading"
          required
        />
        <span v-if="!form.end_date" class="text-red-500">*Campo obrigatório.</span>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="pr-6 pb-8 w-full lg:w-1/3">
        <label for="origin-country" class="form-label">País de Origem</label>

        <select
          id="origin-country"
          v-model="form.country_origin_name"
          class="form-control form-select"
          :menu="['bus']"
          :disabled="loading"
          @change="setOrigin($event)"
        >
          <option :value="null" />
          <option
            v-for="country in countries"
            :key="country"
            :value="country"
            :selected="country === 'Brasil'"
          >
            {{ country }}
          </option>
        </select>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/3">
        <label for="origin-state" class="form-label">Estado de Origem</label>

        <select
          id="origin-state"
          v-model="form.state_origin_id"
          class="form-control form-select"
          :menu="['bus']"
          :disabled="loading || is_international"
          @change="getCities('state_origin_id', 'cities_origin')"
        >
          <option :value="null" />
          <option
            v-for="state_origin in states_origin"
            :key="state_origin.id"
            :value="state_origin.id"
          >
            {{ state_origin.name }}
          </option>
        </select>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/3">
        <label for="origin-city" class="form-label">Cidade de Origem</label>

        <select
          id="origin-city"
          v-model="form.city_origin_id"
          class="form-control form-select"
          :menu="['bus']"
          :disabled="loading || is_international"
        >
          <option :value="null" />
          <option
            v-for="city_origin in cities_origin"
            :key="city_origin.id"
            :value="city_origin.id"
          >
            {{ city_origin.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="pr-6 pb-8 w-full lg:w-1/2">
        <label for="destiny-state" class="form-label">Estado de Destino</label>

        <select
          id="destiny-state"
          v-model="form.state_destiny_id"
          class="form-control form-select"
          :menu="['bus']"
          :disabled="loading"
          @change="getCities('state_destiny_id', 'cities_destiny')"
        >
          <option :value="null" />
          <option v-for="state_destiny in states" :key="state_destiny.id" :value="state_destiny.id">
            {{ state_destiny.name }}
          </option>
        </select>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/2">
        <label for="destiny-city" class="form-label">Cidade de Destino</label>

        <select
          id="destiny-city"
          v-model="form.city_destiny_id"
          class="form-control form-select"
          :menu="['bus']"
          :disabled="loading"
        >
          <option :value="null" />
          <option
            v-for="city_destiny in cities_destiny"
            :key="city_destiny.id"
            :value="city_destiny.id"
          >
            {{ city_destiny.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="pr-6 pb-8 w-full lg:w-1/2" :class="{ hidden: !config.questionnaires }">
        <label for="questionnaire" class="form-label">Questionário</label>

        <select
          id="questionnaire"
          v-model="form.questionnaire_id"
          class="form-control form-select"
          :menu="['SET-mini']"
          :menu-protected="!config.questionnaires"
          :disabled="loading"
          @change="getAnswers()"
        >
          <option :value="null" />
          <option
            v-for="questionnaire in questionnaires"
            :key="questionnaire.id"
            :value="questionnaire.id"
          >
            {{ questionnaire.title }}
          </option>
        </select>
      </div>

      <div
        class="pr-6 pb-8 w-full"
        :class="{ 'lg:w-1/2': config.questionnaires, hidden: !config.answers }"
      >
        <label class="form-label">Avaliações</label>

        <multiselect
          id="rates"
          v-model="form.answers_group"
          placeholder="Selecione..."
          label="label"
          track-by="label"
          :menu="['SET-mini']"
          :menu-protected="!config.answers"
          :custom-label="({ label }) => label"
          :options="rates"
          :multiple="true"
          :disabled="loading"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="false"
          :preselect-first="false"
        >
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template slot="selection" slot-scope="{ values, filter, isOpen }">
            <span v-if="values.length &amp;&amp; !isOpen" class="multiselect__single">
              {{ values.length }} opções selecionadas
            </span>
          </template>
        </multiselect>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-1/2 hidden">
        <label class="form-label">Respostas</label>

        <multiselect
          id="answers"
          v-model="form.answers_code"
          placeholder="Selecione..."
          label="code"
          track-by="code"
          :menu="['SET-mini']"
          :menu-protected="true"
          :custom-label="({ user, answered_at }) => `${user} - ${answered_at}`"
          :options="answers"
          :multiple="true"
          :disabled="loading"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="false"
          :preselect-first="false"
        >
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template slot="selection" slot-scope="{ values, filter, isOpen }">
            <span v-if="values.length &amp;&amp; !isOpen" class="multiselect__single">
              {{ values.length }} opções selecionadas
            </span>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="pr-6 pb-8 w-full lg:w-full" :class="{ hidden: !config.questionnaires }">
        <label for="questionnaire-intelligent" class="form-label">Questionário Inteligente</label>

        <select
          id="questionnaire-intelligent"
          v-model="form.questionnaire_intelligent_id"
          class="form-control form-select"
          :menu="['chart']"
          :menu-protected="!config.questionnaires"
          :disabled="loading"
          @change="getAnswersIntelligent()"
        >
          <option :value="null" />
          <option
            v-for="questionnaire in questionnairesIntelligent"
            :key="questionnaire.id"
            :value="questionnaire.id"
          >
            {{ questionnaire.title }}
          </option>
        </select>
      </div>

      <div class="pr-6 pb-8 w-full lg:w-full hidden">
        <label class="form-label">Respostas</label>

        <multiselect
          id="answers-intelligent"
          v-model="form.answers_intelligent_code"
          placeholder="Selecione..."
          label="code"
          track-by="code"
          :menu="['chart']"
          :menu-protected="true"
          :custom-label="({ code, answered_at }) => `${answered_at} (${code})`"
          :options="answers_intelligent"
          :multiple="true"
          :disabled="loading"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="false"
          :preselect-first="false"
        >
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template slot="selection" slot-scope="{ values, filter, isOpen }">
            <span v-if="values.length &amp;&amp; !isOpen" class="multiselect__single">
              {{ values.length }} opções selecionadas
            </span>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="-mr-6 -mb-12 flex flex-wrap">
      <div class="pr-12 pb-8 w-full">
        <label for="saved-report" class="form-label">Relatórios Salvos</label>

        <select
          id="saved-report"
          v-model="savedReport"
          class="form-control form-select"
          menu="*"
          :disabled="loading"
          @change="setSavedReport()"
        >
          <option :value="null" />
          <option v-for="report_ in reports" :key="report_.id" :value="report_.id">
            {{ report_.alias }}
          </option>
        </select>
      </div>
    </div>

    <div
      v-for="group in groups"
      :key="group"
      class="mx-auto mt-12 rounded border border-gray-300 w-full fieldset"
    >
      <h1 class="text-3xl font-bold" v-if="group !== 'Gráficos'">
        {{ group }}
      </h1>

      <br />

      <div
        v-for="fieldset in indicators[group]"
        :key="indicators[group].indexOf(fieldset)"
        class="text-sm flex"
      >
        <div v-for="indicator in fieldset" :key="indicator.id" class="w-1/4 mx-3 mb-3">
          <label class="form-label" :class="classes(indicator)">
            <input
              :id="`i-${indicator.id}`"
              :class="cityFilter(indicator)"
              :value="indicator.id"
              :disabled="indicator.disabled || loading"
              type="checkbox"
              @change="setIndicator($event, indicator)"
            />
            {{ indicator.label }}
          </label>
        </div>
      </div>
    </div>

    <div v-if="hasSourcedData" class="mt-4">Fontes: {{ sources }}</div>

    <div class="text-center mx-auto my-12 w-full">
      <div class="flex w-1/2 mx-auto mb-3">
        <div v-if="$page.props.auth.user.email === 'super@smart-destination.com'">
          <button
            class="btn-indigo mx-4"
            style="background: red !important"
            type="button"
            :disabled="loading"
            @click="toggleUploadDocumentDialog"
          >
            Upload Pdf
          </button>
        </div>
        <div v-if="$page.props.auth.user.email !== 'super@smart-destination.com'">
          <button class="btn-indigo mx-4" style="background: red !important" type="button" :disabled="loading" @click="downloadPdf">
            Download Pdf
          </button>
        </div>
        <loading-button
          :loading="form.processing"
          :disabled="loading"
          class="btn-indigo"
          @click="search()"
        >
          Consultar
        </loading-button>

        <button
          class="btn-indigo mx-4"
          type="button"
          :disabled="loading"
          @click="$parent.$parent.save(formData)"
        >
          Salvar
        </button>
        <inertia-link
          class="btn-indigo mr-auto"
          :href="route('indicators.compare')"
          :disabled="loading"
        >
          Comparar
        </inertia-link>
      </div>

      <p v-if="timer" id="timer-alert" class="timer-fade text-yellow-500">
        <strong>Aguarde...</strong> <br />
        <br />
        Essa ação pode levar alguns minutos.
      </p>
    </div>

    <Dialog position="center" :visible.sync="showUploadDocumentDialog" :dismissable-mask="true">
      <div style="display: flex; flex-direction: column; justify-content: center; width: 400px">
        <file-input
          v-model="pdfDocument"
          type="file"
          accept="application/pdf"
          labelButton="Upload PDF"
        />
        <div style="margin: 20px 0"></div>
        <select-input
          v-model="roleSelected"
          class="pr-6 pb-8 w-full lg:w-1/2"
          label="Papel do Usuário"
        >
          <option :value="null" />
          <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
        </select-input>

        <div style="margin: 20px 0"></div>

        <loading-button
          :loading="uploading"
          class="btn-indigo mx-4"
          type="button"
          @click="uploadPdfDocument"
          :styles="{ width: '100px', 'align-self': 'center' }"
        >
          Upload
        </loading-button>
      </div>
    </Dialog>
  </form>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import FileInput from './FileInput'
import Dialog from 'primevue/dialog'
import Toast from 'primevue/toast'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Multiselect,
    LoadingButton,
    FileInput,
    Dialog,
    SelectInput,
    Toast,
  },
  props: {
    roleId: Number,
    state: Number,
    city: Array,
    indicators: Object,
    categories: Object,
    reports: Array,
    report: Number,
    questionnaires: Array,
    questionnairesIntelligent: Array,
    rates: Array,
    data: Object,
    results: Object,
    config: Object,
  },
  data() {
    return {
      loading: Boolean(this.data),
      uploading: false,
      showUploadDocumentDialog: false,
      roleSelected: null,
      roles: [],
      timer: false,
      searching: false,
      pdfDocument: null,
      form: this.$inertia.form({
        state_id: this.data?.state_id,
        city_id: this.data?.city_id,
        country_origin_name: this.data?.country_origin_name,
        state_origin_id: this.data?.state_origin_id,
        city_origin_id: this.data?.city_origin_id,
        state_destiny_id: this.data?.state_destiny_id,
        city_destiny_id: this.data?.city_destiny_id,
        start_date: this.data?.start_date,
        questionnaire_id: this.data?.questionnaire_id,
        questionnaire_intelligent_id: this.data?.questionnaire_intelligent_id,
        answers_code: this.data?.answers_code,
        answers_intelligent_code: this.data?.answers_intelligent_code,
        answers_group: this.data?.answers_group,
        end_date: this.data?.end_date,
        indicator_ids: this.data?.indicator_ids ?? [],
        current_menu: null,
      }),
      cities: [],
      cities_origin: [],
      cities_destiny: [],
      states: [],
      states_origin: [],
      countries: [],
      answers: [],
      answers_intelligent: [],
      savedReport: this.report,
      is_international: false,
      get groups() {
        return ['Planilha', 'Gráficos', 'Outros']
      },
      get formData() {
        return {
          state_id: this.form.state_id,
          city_id: this.form.city_id,
          country_origin_name: this.form.country_origin_name,
          state_origin_id: this.form.state_origin_id,
          city_origin_id: this.form.city_origin_id,
          state_destiny_id: this.form.state_destiny_id,
          city_destiny_id: this.form.city_destiny_id,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          questionnaire_id: this.form.questionnaire_id,
          questionnaire_intelligent_id: this.form.questionnaire_intelligent_id,
          answers_code: this.form.answers_code,
          answers_intelligent_code: this.form.answers_intelligent_code,
          answers_group: this.form.answers_group,
          indicator_ids: this.form.indicator_ids,
        }
      },
      get hasIBGE() {
        const IBGE = [
          2, 1, 3, 4, 5, 6, 11, 12, 21, 20, 19, 23, 22, 17, 7, 8, 14, 18, 13, 10, 16, 15, 9,
        ]

        const MENUS = ['home', 'flag', 'briefcase', 'departure']

        return Boolean(this.formData.indicator_ids.some((id) => IBGE.includes(id))) &&
          MENUS.includes(this.$this.$parent.$parent.$parent.activeMenu())
          ? 'IBGE'
          : ''
      },
      get hasANAC() {
        const ANAC = [91, 24, 56, 57]

        const MENUS = ['home', 'bus']

        return Boolean(this.formData.indicator_ids.some((id) => ANAC.includes(id))) &&
          MENUS.includes(this.$this.$parent.$parent.$parent.activeMenu())
          ? 'ANAC'
          : ''
      },
      get hasANTT() {
        const ANTT = [54, 52, 53]

        const MENUS = ['home', 'bus']

        return Boolean(this.formData.indicator_ids.some((id) => ANTT.includes(id))) &&
          MENUS.includes(this.$this.$parent.$parent.$parent.activeMenu())
          ? 'ANTT'
          : ''
      },
      get sources() {
        const sources = [this.hasIBGE, this.hasANAC, this.hasANTT]

        return sources.filter((source) => source.length > 0).join(', ')
      },
      $this: this,
      get hasSourcedData() {
        return (
          Object.keys(this.$this.results ?? {}).length > 1 &&
          Boolean(this.hasIBGE || this.hasANAC || this.hasANTT)
        )
      },
    }
  },
  created() {
    Promise.all([
      this.getCountries(),
      this.getStates(),
      this.getStates('states_origin', true),
    ]).then(() => {
      if (this.data) {
        Promise.all([
          this.getCities(),
          this.getCities('state_origin_id', 'cities_origin'),
          this.getCities('state_destiny_id', 'cities_destiny'),
        ]).then(() => {
          this.form.indicator_ids.forEach((id) => {
            const indicator = document.getElementById(`i-${id}`)

            if (indicator) {
              indicator.checked = true
            }
          })

          if (this.form.city_id) {
            this.setCC()
          }

          if (!this.config.questionnaires) {
            if (this.questionnaires.length === 1) {
              this.form.questionnaire_id = this.questionnaires[0]['id']

              this.getAnswers().then((answers) => {
                answers.forEach((answer) => {
                  if (!this.form.answers_code) {
                    this.form.answers_code = []
                  }

                  this.form.answers_code.push(answer)
                })
              })
            }

            if (this.questionnairesIntelligent.length === 1) {
              this.form.questionnaire_intelligent_id = this.questionnairesIntelligent[0]['id']

              this.getAnswersIntelligent().then((answers_intelligent) => {
                answers_intelligent.forEach((answer_intelligent) => {
                  if (!this.form.answers_intelligent_code) {
                    this.form.answers_intelligent_code = []
                  }

                  this.form.answers_intelligent_code.push(answer_intelligent)
                })
              })
            }
          }

          if (!this.config.answers) {
            if (!this.form.answers_group) {
              this.form.answers_group = []
            }

            if (this.rates.length === 1) {
              this.form.answers_group.push(this.rates[0])
            }
          }

          this.loading = false
        })
      }
    })
  },
  mounted() {
    this.getAllRoles()
  },
  methods: {
    async downloadPdf() {
      try {
        const response = await axios.get(`/api/users-document/${this.roleId}`);
        if (response.data.document) {
          window.open(response.data.document)
        } else {
          this.$toast.add({
            severity: 'info',
            summary: 'Você não possui documento para download!',
            life: 15000,
          })
        }
        console.log(response.data)
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro no download do arquivo!',
          life: 15000,
        })
      }
    },
    async uploadPdfDocument() {
      try {
        this.uploading = true
        const formData = new FormData()
        const renamedFile = new File([this.pdfDocument], 'document.pdf', {
          type: this.pdfDocument.type,
        })

        formData.append('document', renamedFile)
        formData.append('role_id', this.roleSelected)
        formData.append('document_type', 'pdf')
        formData.append('url', 'indicators')

        await axios.post('/upload/file-manager', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        this.$toast.add({
          severity: 'success',
          summary: 'Documento salvo com sucesso!',
          life: 15000,
        })
      } catch (error) {
        console.error('Erro ao enviar o documento:', error.response ? error.response.data : error)
        this.$toast.add({
          severity: 'error',
          summary: 'Erro ao salvar o documento!',
          life: 15000,
        })
      } finally {
        this.uploading = false
      }
    },

    async getAllRoles() {
      try {
        const response = await axios.get('/api/roles')
        this.roles = response.data
      } catch (error) {
        console.log(error)
      }
    },
    toggleUploadDocumentDialog() {
      this.showUploadDocumentDialog = !this.showUploadDocumentDialog
    },
    search() {
      /*if (!this.searching) {
        setTimeout(this.search, 5e2)

        this.searching = true
      }*/

      this.timer = false

      let timeout = null

      this.form.current_menu = document?.getElementById('menu_active')?.value

      this.form.post(this.route('indicators.search'), {
        onStart: () => (timeout = setTimeout(() => (this.timer = true), 1e4)),
        onFinish: () => {
          if (timeout) {
            clearTimeout(timeout)

            timeout = null
          }

          this.timer = false
          this.searching = false
        },
      })
    },
    getCountries() {
      return axios.get(this.route('countries')).then((res) => (this.countries = res.data))
    },
    getStates(state = 'states', ignore = false) {
      const req = {}

      if (this.state && !ignore) {
        req['params'] = {
          stateId: this.state,
        }
      }

      return axios
        .get(this.route(`state${ignore || !this.state ? 's' : ''}`), req)
        .then((res) => (this[state] = res.data))
    },
    getCities(state = 'state_id', city = 'cities') {
      const req = {
        params: {},
      }

      if (!this.form[state] && !this.state && this[city]) {
        this[city] = []

        return
      }

      if (this.city && (city === 'cities' || city === 'cities_destiny')) {
        Promise.all(
          this.city.map((cityId) =>
            axios
              .get(this.route('city'), { params: { cityId } })
              .then((res) => (res.data ? res.data[0] : null)),
          ),
        ).then((cities) => (this[city] = cities))

        return
      }

      req.params['stateId'] = this.form[state]

      return axios.get(this.route('cities'), req).then((res) => (this[city] = res.data))
    },
    getAnswers() {
      if (!this.form.questionnaire_id) {
        this.form.answers_code = []
        this.answers = []
      }

      return axios
        .get(this.route('questionnaires.answers', { id: this.form.questionnaire_id }))
        .then((res) => {
          this.answers = res.data

          if (this.config.questionnaires) {
            this.form.answers_code = this.answers
          }

          return res.data
        })
    },
    getAnswersIntelligent() {
      if (!this.form.questionnaire_intelligent_id) {
        this.form.answers_intelligent_code = []
        this.answers_intelligent = []
      }

      return axios
        .get(
          this.route('questionnaires.intelligent.answers', {
            id: this.form.questionnaire_intelligent_id,
          }),
        )
        .then((res) => {
          this.answers_intelligent = res.data

          if (this.config.questionnaires) {
            this.form.answers_intelligent_code = this.answers_intelligent
          }

          return res.data
        })
    },
    setSavedReport() {
      window.location.replace(this.route('indicators', { report: this.savedReport }))
    },
    setIndicator(event, indicator) {
      if (!event.target?.checked) {
        this.form.indicator_ids.splice(this.form.indicator_ids.indexOf(indicator.id), 1)

        return
      }

      this.form.indicator_ids.push(indicator.id)
    },
    setOrigin(event) {
      this.is_international = event.target.value !== ''

      if (this.is_international) {
        this.form.state_origin_id = null
        this.form.city_origin_id = null
      }
    },
    cityFilter(indicator) {
      const classes = {
        'i-cc': true,
      }

      if (indicator.city_id) {
        classes[`i-cc-${indicator.city_id}`] = true
      } else {
        classes['i-cc-a'] = true
      }

      return classes
    },
    setCC() {
      if (!this.form.city_id) {
        Array.from(document.getElementsByClassName('i-cc')).forEach((i) =>
          i.parentElement.classList.remove('hidden'),
        )

        return
      }

      Array.from(document.getElementsByClassName('i-cc')).forEach((i) => {
        i.parentElement.classList.add('hidden')

        if (!i.classList.contains('i-cc-a')) {
          const index = this.form.indicator_ids.indexOf(Number(i.id.replace('i-', '')))

          if (index !== -1) {
            this.form.indicator_ids.splice(index, 1)
          }
        }
      })

      Array.from([
        Array.from(document.getElementsByClassName(`i-cc-${this.form.city_id}`)),
        Array.from(document.getElementsByClassName('i-cc-a')),
      ]).forEach((is) => is.forEach((i) => i.parentElement.classList.remove('hidden')))
    },
    classes(indicator) {
      const classes = {}

      const category = (() => {
        for (const category in this.categories) {
          if (
            this.categories[category].indicators
              .map((category_indicator) => category_indicator.id)
              .includes(indicator.id)
          ) {
            return category
          }
        }

        return 'home'
      })()

      classes[`text-indicator-${category}`] = true
      classes[`text-indicator-${category}-disabled`] = indicator.disabled

      return classes
    },
  },
}
</script>
